import angular from "angular";

import AdminUsersModuleRouting from "./admin-users.module.routing";
import AdminUserInfoModuleRouting from "./admin/admin-user-info.module.routing";
import AdminBicycleOwnerInfoModuleRouting from "./bicycle-owner/admin-bicycle-owner-info.module.routing";
import AdminOrganisationOwnerInfoModuleRouting from "./organisation-owner/admin-organisation-owner-info.module.routing";
import AdminServiceProviderInfoModuleRouting from "./service-provider/admin-service-provider-info.module.routing";

export default angular
  .module("vt-admin-users", [])
  .config(AdminUsersModuleRouting)
  .config(AdminUserInfoModuleRouting)
  .config(AdminBicycleOwnerInfoModuleRouting)
  .config(AdminOrganisationOwnerInfoModuleRouting)
  .config(AdminServiceProviderInfoModuleRouting);
